import React, { useEffect, useState } from 'react';
import Header from '../component/Header';
import Sidebar from '../component/Sidebar';
import { Link } from 'react-router-dom';
import { getToken } from '../utils/tokenHelper';
import SymptomForm from '../component/SymptomForm';
import CircularProgress from '@mui/material/CircularProgress';
import { FaGift } from "react-icons/fa6";

const Health = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [profile, setProfile] = useState({ first_name: '', last_name: '' });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [response, setResponse] = useState('');

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    useEffect(() => {
        const token = getToken();
        console.log('Retrieved token:', token);
        if (!token) {
            console.error('No token found');
            setResponse('Error: No token found');
            return;
        }

        const myHeaders = new Headers();
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Authorization", `Bearer ${token}`);

        const requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        fetch("https://devapi.quickcare.ng/api/v1/user/profile", requestOptions)
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Network response was not ok ' + response.statusText);
                }
                return response.json();
            })
            .then((result) => {
                // console.log('Name: ', result.data.first_name + ' ' +result.data.last_name);
                setProfile(result.data);
                setLoading(false);
            })
            .catch((error) => {
                setError(error);
                setLoading(false);
            });
    }, []);

    if (loading) {
        return (
            <div className="fixed inset-0 flex items-center justify-center bg-[#F9FAFB]">
                <div className="text-center">
                    <CircularProgress className="text-[#069125]" />
                    <p className="mt-4 text-gray-600">Loading your health profile...</p>
                </div>
            </div>
        );
    } 

    if (error) {
        return (
            <div className="fixed inset-0 flex items-center justify-center bg-[#F9FAFB]">
                <div className="text-center p-4 max-w-md">
                    <div className="text-red-500 mb-4">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                    </div>
                    <h3 className="text-lg font-medium text-gray-900">Token Expired, please login </h3>
                    
                    <div className="mt-4">
                        <Link 
                        to="/login"
                        className="px-4 py-2 bg-[#069125] text-white rounded hover:bg-[#057a20] transition-colors"
                        >
                            Login
                        </Link>
                    </div>
                </div>
            </div>
        ); 
    }

    return (
       <div className='w-full flex items-start justify-center bg-[#F9FAFB] relative'>
            {/* Sidebar with conditional rendering for mobile */}
            <div className={`${isSidebarOpen ? 'block' : 'hidden'} lg:block w-full lg:w-1/6 fixed left-0 top-0 h-full z-50`}>
                <Sidebar toggleSidebar={toggleSidebar} />
            </div>

            {/* Overlay for mobile when sidebar is open */}
            {isSidebarOpen && (
                <div 
                    className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
                    onClick={toggleSidebar}
                    toggleSidebar={toggleSidebar} 
                    isSidebarOpen={isSidebarOpen}
                ></div>
            )}

            <div className='flex flex-col w-full space-y-4 lg:ml-[16.67%]'>
                <div>
                     <Header 
                        isSidebarOpen={isSidebarOpen} 
                        toggleSidebar={toggleSidebar} 
                        title='Home'
                     />  
                </div>

                <div className='p-4 lg:p-[30px]'>
                    <div className='mb-[30px]'>
                        <p className='instrument-sans-bold text-lg lg:text-[24px]'>
                            Welcome back,  {profile.first_name} {profile.last_name}
                        </p>

                        <p className='text-[#8B8D8C] mt-2 instrument-sans-medium'>
                            We're here to help you feel better quickly.
                        </p>
                    </div>

                    <div className='bg-white py-10 px-6 rounded-xl border border-[#E9EBE9] flex items-start justify-start gap-4'>
                        <div className='mt-1 px-0.5 py-1.5 w-10 h-10 bg-[#DBFFE3] items-center justify-center text-[#069125] rounded hidden lg:flex'>
                            <FaGift />
                        </div>
                        <div>
                            <div className='mb-[30px]'>
                                <p className='instrument-sans-semibold text-lg text-[#262323] lg:text-[20px]'>
                                    How can we assist you today?
                                </p>

                                <p className='text-[#8B8D8C] mt-2 instrument-sans-medium'>
                                    Please fill the form to describe your symptoms to further assist you.
                                </p>
                            </div>
                            <SymptomForm />
                        </div>
                    </div>
                </div>
            </div>
       </div>
    );
};

export default Health;